var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-saas",
      attrs: {
        refs: "menu",
        "default-active": _vm.menuActive,
        "unique-opened": true
      }
    },
    [
      _vm._l(_vm.list, function(item, index) {
        return [
          item.subMenuList && item.subMenuList.length > 0
            ? [
                _c(
                  "el-submenu",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !item.noshow,
                        expression: "!item.noshow"
                      }
                    ],
                    key: index,
                    staticClass: "saas-menu-onetitle",
                    attrs: { index: index + 1 + "" }
                  },
                  [
                    _c("template", { slot: "title" }, [
                      _c("i", {
                        staticClass: "el-icon-home",
                        style: "background-image: url(" + item.icon + ")"
                      }),
                      _vm._v(" "),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-menu-item-group",
                      [
                        _vm._l(item.subMenuList, function(ite, idx) {
                          return [
                            ite.subMenuList && ite.subMenuList.length > 0
                              ? [
                                  _c(
                                    "el-submenu",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !item.noshow || !ite.noshow,
                                          expression:
                                            "!item.noshow || !ite.noshow"
                                        }
                                      ],
                                      key: idx,
                                      attrs: {
                                        index: index + 1 + "-" + (idx + 1)
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "padding-left": "6px"
                                            },
                                            attrs: { slot: "title" },
                                            slot: "title"
                                          },
                                          [_vm._v(_vm._s(ite.name))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-menu-item-group",
                                        [
                                          _vm._l(ite.subMenuList, function(
                                            it,
                                            id
                                          ) {
                                            return [
                                              _c(
                                                "el-menu-item",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        !item.noshow ||
                                                        !ite.noshow ||
                                                        !it.noshow,
                                                      expression:
                                                        "!item.noshow || !ite.noshow || !it.noshow"
                                                    }
                                                  ],
                                                  key: id,
                                                  staticStyle: {
                                                    "padding-left": "60px"
                                                  },
                                                  attrs: {
                                                    index:
                                                      index +
                                                      1 +
                                                      "-" +
                                                      (idx + 1) +
                                                      "-" +
                                                      (id + 1)
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.menuClick(
                                                        it,
                                                        index +
                                                          1 +
                                                          "-" +
                                                          (idx + 1) +
                                                          "-" +
                                                          (id + 1)
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(it.name))
                                                  ])
                                                ]
                                              )
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    ],
                                    2
                                  )
                                ]
                              : !ite.subMenuList || ite.subMenuList.length == 0
                                ? [
                                    _c(
                                      "el-menu-item",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !item.noshow || !ite.noshow,
                                            expression:
                                              "!item.noshow || !ite.noshow"
                                          }
                                        ],
                                        key: idx,
                                        staticClass: "menu-two-content",
                                        attrs: {
                                          index: index + 1 + "-" + (idx + 1)
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.menuClick(
                                              ite,
                                              index + 1 + "-" + (idx + 1)
                                            )
                                          }
                                        }
                                      },
                                      [_c("span", [_vm._v(_vm._s(ite.name))])]
                                    )
                                  ]
                                : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  2
                )
              ]
            : !item.subMenuList || item.subMenuList.length == 0
              ? [
                  _c(
                    "el-menu-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !item.noshow,
                          expression: "!item.noshow"
                        }
                      ],
                      key: index,
                      staticClass: "saas-menu-one menu-one-content",
                      staticStyle: {
                        "padding-left": "0px",
                        "font-size": "14px"
                      },
                      attrs: { index: index + 1 + "" },
                      on: {
                        click: function($event) {
                          _vm.menuClick(item, index + 1 + "")
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-home",
                        style: "background-image: url(" + item.icon + ")"
                      }),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(item.name))
                      ])
                    ]
                  )
                ]
              : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }